import { Component, inject } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { MenuService } from '@frontend/shared/services/menu.service';
import { TitleService } from '@frontend/shared/services/title.service';
import { Store } from '@ngrx/store';
import { debounceTime, filter } from '@proman/rxjs-common';
import { Entity } from '@proman/services/entity.service';
import { LanguageConfigService } from '@proman/services/language-config.service';
import { closeDialog } from '@proman/store/system-options';
import { getPendingRequests } from '@proman/store/utils';
import { Observable } from 'rxjs';

@Component({
    selector: 'pm-app',
    template: `
        <div class="App-buffer-container" [ngClass]="{ VisibilityHidden: !(isPendingRequests$ | async) }">
            <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
        </div>
        <router-outlet></router-outlet>
    `,
    styles: [
        `
            .App-buffer-container {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 4px;
                z-index: 2;
            }
        `,
    ],
    standalone: false,
})
export class AppComponent {
    private Entity = inject(Entity);
    Title = inject(TitleService);
    private Router = inject(Router);
    private Menu = inject(MenuService);
    private LangConfig = inject(LanguageConfigService);
    private store = inject(Store);

    isPendingRequests$: Observable<number>;

    constructor() {
        this.LangConfig.set();

        this.Router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((val) => {
            this.handleStateChange();
        });

        // TODO(perf): Drop this no-op subscription or wrap behind an env flag to avoid an extra Navigation stream listener.
        this.Router.events.subscribe((event: any) => {
            // if (event instanceof NavigationStart) console.trace('navigation start', event);
            //
            // if (event instanceof NavigationEnd) console.trace('navigation end', event);
        });

        this.setCustomScrollbar();

        this.isPendingRequests$ = this.store.select(getPendingRequests).pipe(debounceTime(25));

        if (!window.localStorage.getItem('prefs.language')) window.localStorage.setItem('prefs.language', 'en');
    }

    handleStateChange = () => {
        setTimeout(() => {
            this.Title.setFromState(this.Menu.activeCategoryTab || this.Menu.activeCategory);
        }, 40);
        this.store.dispatch(closeDialog());
    };

    getState(state: any): any {
        if (state.translation) return state;
        else if (state.parent && state.parent !== 'proman') return this.getState(state.parent);
        else return state;
    }

    setCustomScrollbar() {
        if (navigator.appVersion.indexOf('Mac') === -1) document.querySelector('body').classList.add('CustomScroll');
    }
}
